import { CountryInfoModel } from '@b2c/services/nation';
import { createContext } from 'react';

export const CountryInfoContext = createContext<{
  countryInfoList: CountryInfoModel[];
}>({
  countryInfoList: [],
});
